// assets/cart-upsell.js
async function getCart() {
  const r = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
  if (!r.ok) throw new Error('cart read failed');
  return r.json();
}
async function addVariant(variantId) {
  const r = await fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  });
  if (!r.ok) {
    let msg = 'Kan shipping protection niet toevoegen.';
    try { const j = await r.json(); if (j && j.description) msg = j.description; } catch {}
    throw new Error(msg);
  }
}
async function removeByLine(line) {
  const r = await fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ line, quantity: 0 })
  });
  if (!r.ok) throw new Error('Kan shipping protection niet verwijderen.');
}

function execScripts(node) {
  node.querySelectorAll('script').forEach(old => {
    const s = document.createElement('script');
    if (old.type) s.type = old.type;
    if (old.src) s.src = old.src; else s.textContent = old.textContent;
    old.replaceWith(s);
  });
}

async function refreshDrawerContent() {
  const sectionId =
    document.querySelector('.cart-items-component')?.dataset.sectionId ||
    document.querySelector('.cart-drawer__summary')?.dataset.sectionId;
  if (!sectionId) return false;

  const url = `${location.pathname}?sections=${encodeURIComponent(sectionId)}&ts=${Date.now()}`;
  const res = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
  if (!res.ok) return false;

  const html = (await res.json())[sectionId];
  if (!html) return false;

  const tmp = document.createElement('div'); tmp.innerHTML = html;
  const fresh = tmp.querySelector('.cart-drawer__content');
  const live  = document.querySelector('.cart-drawer__content');
  if (fresh && live) {
    live.replaceWith(fresh);
    execScripts(fresh);
    return true;
  }
  return false;
}

function bindUpsellToggle() {
  const host   = document.getElementById('cart-upsell');
  const toggle = document.getElementById('cart-upsell-toggle');
  if (!host || !toggle) return;
  const variantId = Number(host.dataset.variantId || 0);
  if (!variantId) return;

  toggle.addEventListener('change', async () => {
    toggle.disabled = true;
    try {
      const cart = await getCart();
      const idx = cart.items.findIndex(i => i.variant_id === variantId);
      const lineIndex = idx >= 0 ? idx + 1 : null;

      if (toggle.checked) {
        if (lineIndex == null) await addVariant(variantId);
        // bestond al → niets
      } else {
        if (lineIndex != null) await removeByLine(lineIndex);
        // bestond niet → niets
      }

      const ok = await refreshDrawerContent();
      if (!ok) location.reload();

      window.dispatchEvent(new Event('cart:updated'));
      window.dispatchEvent(new Event('cart:refresh'));
    } catch (e) {
      console.error(e);
      // zet UI terug naar vorige staat als het faalt
      toggle.checked = !toggle.checked;
      alert(e.message || 'Er ging iets mis bij het aanpassen van de shipping protection.');
    } finally {
      toggle.disabled = false;
    }
  });
}

document.addEventListener('DOMContentLoaded', bindUpsellToggle);
// als de drawer via morph/replace opnieuw in de DOM komt:
document.addEventListener('shopify:section:load', bindUpsellToggle);
